module.exports = __webpack_public_path__ + "img/logo.e24bcd41.png";